import showCropSeasonMismatchModal from 'helpers/showCropSeasonMismatchModal';
import { shouldShowPlanCropSeasonMismatch } from 'helpers/cropSeasonMismatch';
import useSelectedCropSeasonIds from 'hooks/useSelectedCropSeasonIds';
import { OperationType } from 'components/RecordsListView/constants';
import { RecordSourceType } from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';
import { Plan } from '../ConvertPlanModalV2/types';

const usePlanToOperationAction = () => {
  const { selectedCropSeasonIds } = useSelectedCropSeasonIds();

  const handleConvertPlanToOperationAction = (
    currentPlan: Plan,
    operationType: OperationType,
    recordSourceType: RecordSourceType.RECOMMENDATION | RecordSourceType.PLANS,
    callback: () => void
  ) => {
    const hasMismatch = shouldShowPlanCropSeasonMismatch(
      currentPlan,
      selectedCropSeasonIds
    );

    if (hasMismatch) {
      showCropSeasonMismatchModal(callback, operationType, recordSourceType);
    } else {
      callback();
    }
  };

  return {
    handleConvertPlanToOperationAction
  };
};

export default usePlanToOperationAction;
